<template>
  <div class="rounded-small border-outline-variant w-full border p-2">
    <div class="mb-2 flex flex-row items-center gap-1">
      <div class="text-label-large text-primary flex grow items-center gap-2">
        <BaseIcon>target</BaseIcon>
      </div>
    </div>

    <div>
      <h4 class="text-body-large">{{ objective.title }}</h4>
      <p v-if="objective.description" class="text-body-medium text-on-surface-variant mt-1">
        {{ objective.description }}
      </p>
      <p class="text-body-small text-on-surface-variant mt-2">
        {{ $t('common.agreed') }}
        {{
          useDisplayDate(objective.createdAt, {
            dayName: 'none',
            monthName: 'number',
            year: 'short',
            displayYear: 'always',
          })
        }}
        <template v-if="objective.achievedAt">
          · {{ $t('objective.achieved') }}
        </template>
      </p>
      <ul v-if="objective.actions?.length" class="mt-2 flex flex-col gap-0.5">
        <li
          v-for="action in objective.actions"
          :key="action.id"
          class="text-body-small text-on-surface-variant"
        >
          {{ action.isChecked ? '☑' : '☐' }} {{ action.title }}
        </li>
      </ul>
    </div>
  </div>
</template>
<script setup lang="ts">
  import type { Objective } from '@/core/composables/use-objectives'
  import type { FeedbackTopic } from '@/core/models/feedback-topic'
  import BaseIcon from '@/core/components/base/icon/BaseIcon.vue'
  import { useDisplayDate } from '@/core/composables/use-display-date'

  interface Props {
    objective: Objective
    feedbackTopic?: FeedbackTopic
  }

  defineProps<Props>()
</script>
